import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import {
  useSearchDispatch,
} from '../../hooks/use_search_state';
import { toggleValue } from '../../utils/togglers';
import Categories from './filters/categories';
import Brands from './filters/brands';
import Merchants from './filters/merchants';
import SortOnSale from './filters/sort_on_sale';

export default function Filters(props) {
  const {
    unfilteredResults,
    style,
    affiliateMerchants,
    clearBtnClassName = 'snapgadget-btn snapgadget-btn-primary snapgadget-btn-sm',
    loading,
    hideSort,
    hideOnSaleOnly,
    settings,
  } = props;

  const {
    setPage,
  } = useSearchDispatch();

  const houseKeeping = useCallback(() => {
    setPage(0);
  }, [setPage]);

  const toggle = useCallback((val, set, curr) => {
    houseKeeping();
    toggleValue(val, set, curr);
  }, [houseKeeping]);

  const containerClassName = hideSort && hideOnSaleOnly
    ? 'snapgadget-search-facets-min'
    : 'snapgadget-search-facets';

  return (
    <div className={containerClassName} style={style}>
      <Merchants
        unfilteredResults={unfilteredResults}
        loading={loading}
        affiliateMerchants={affiliateMerchants}
        houseKeeping={houseKeeping}
      />
      <Categories
        toggle={toggle}
        unfilteredResults={unfilteredResults}
        loading={loading}
        settings={settings}
      />
      <Brands
        toggle={toggle}
        unfilteredResults={unfilteredResults}
        loading={loading}
      />
      <SortOnSale
        hideSort={hideSort}
        hideOnSaleOnly={hideOnSaleOnly}
        clearBtnClassName={clearBtnClassName}
        houseKeeping={houseKeeping}
      />
    </div>
  );
}

Filters.propTypes = {
  unfilteredResults: PropTypes.arrayOf(PropTypes.shape({
    lngMerchantId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  })).isRequired,
  style: PropTypes.shape({}),
  affiliateMerchants: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string,
  })),
  clearBtnClassName: PropTypes.string,
  loading: PropTypes.bool,
  hideSort: PropTypes.bool,
  hideOnSaleOnly: PropTypes.bool,
  settings: PropTypes.shape({
    customCategories: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
      query: PropTypes.string,
    })),
  }),
};

Filters.defaultProps = {
  style: {},
  affiliateMerchants: [],
  clearBtnClassName: '',
  loading: false,
  hideSort: false,
  hideOnSaleOnly: false,
  settings: {},
};
